export default __webpack_public_path__ + "static/media/Icon-Holiday.9e29b8e1.svg";